import React from "react";

import nodataImage from "../../assets/images/svg/nodataImage.svg";

const NoDataPortfolio = () => {
  return (
    <div
      style={{
        backgroundColor: "#F6F7FA",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        gap: "32px",
        borderRadius: "15px",
        height: "300px",
        width: "100%",
        marginTop: "20px",
      }}
    >
      <img
        style={{
          width: "fit-content",
        }}
        src={nodataImage}
        alt=""
      />
      <p
        style={{
          fontFamily: "Encode Sans",
          color: "#7E8899",
          fontWeight: "600",
          fontSize: "18px",
        }}
      >
        No data found
      </p>
    </div>
  );
};

export default NoDataPortfolio;
